import { ChartType } from 'chart.js';

import { Charting }        from '../../../types/charting';
import { ChartingService } from '../../../services';
import { useSystemToasts } from '../../useSystem';

type HookOptions = Charting.Reporting.ChartReportExportHookOptions<any>;

type HookType = ( options: HookOptions ) =>
	Pick<ReturnType<Charting.Reporting.ChartReportExportHookMethod<ChartType, any>>,
		"handleCopiedtoClipboard" |
		"handleCSVGenerated" |
		"handleSaveAsImage">;

export const useChartReportExport: HookType = ( options ) => {
	
	const toastActions = useSystemToasts();
	
	/* Handler on Text Copy */
	const handleCopiedtoClipboard: ReturnType<HookType>['handleCopiedtoClipboard'] = ( text: string, result: boolean ) => {
		
		if( result ){
			
			toastActions.success( 'Report Copied!', null );
			
		} else {
			
			toastActions.error( 'Copy Failed!', 'An issue prevented the report from being copied.' );
		}
	}
	
	/* Handler on CSV Generation */
	const handleCSVGenerated: ReturnType<HookType>['handleCSVGenerated'] = () => {
		
		toastActions.success( 'CSV Generated!' );
	}
	
	/* Handler on Image Generation */
	const handleSaveAsImage: ReturnType<HookType>['handleSaveAsImage'] = async () => {
		
		const chartEntity   = options.chartRef.current,
		      mimeType      = 'image/jpg',
		      fileExtension = 'jpg';
		
		if( !chartEntity ){
			
			toastActions.error( 'Could not find viable report element!' );
			
			return;
		}
		
		try{
			
			await ChartingService.saveChartAsImage( chartEntity, mimeType, `Report - ${ options.title }.${ fileExtension }` );
			
			toastActions.success( 'Report image generated successfully!' );
			
		} catch( e ) {
			
			toastActions.error( e.message );
		}
	}
	
	return {
		handleCopiedtoClipboard,
		handleCSVGenerated,
		handleSaveAsImage,
	};
};
